/**
 * Search Filter For Grant
 */
jQuery( document ).ready( function() {
	jQuery( '.orgtype-checkbox' ).on( 'change', function() {
		const value = jQuery( this ).val();
		const isChecked = jQuery( this ).prop( 'checked' );

		const checkboxLabel = jQuery( '.checkbox-label[for="' + jQuery( this ).attr( 'id' ) + '"]' );
		let appendedDiv = jQuery( '.select__tag:contains("' + value + '")' );

		if ( isChecked ) {
			jQuery( this ).addClass( 'active' );
			appendedDiv.addClass( 'active' );
			if ( appendedDiv.length === 0 ) {
				// Append div on frontend
				appendedDiv = jQuery( '<div>' ).addClass( 'select__tag d-flex active' );
				const spanElement = jQuery( '<span>' ).text( value );
				appendedDiv.append( spanElement );
				jQuery( '#selected-value-container' ).append( appendedDiv );
			}
		} else {
			jQuery( this ).removeClass( 'active' );
			appendedDiv.removeClass( 'active' );
			appendedDiv.filter( ':contains("' + value + '")' ).remove(); // Remove corresponding HTML
		}
	} );

	// Handle appended div click event
	jQuery( document ).on( 'click', '.select__tag', function() {
		const value = jQuery( this ).find( 'span' ).text();
		const checkbox = jQuery( '.orgtype-checkbox[value="' + value + '"]' );
		checkbox.prop( 'checked', false );
		checkbox.trigger( 'change' );
		( this ).remove();
	} );

	jQuery( '.catagory-checkbox' ).on( 'change', function() {
		const value = jQuery( this ).val();
		const isChecked = jQuery( this ).prop( 'checked' );

		const checkboxLabel = jQuery( '.checkbox-label[for="' + jQuery( this ).attr( 'id' ) + '"]' );
		let appendedDiv = jQuery( '.select__tag:contains("' + value + '")' );

		if ( isChecked ) {
			jQuery( this ).addClass( 'active' );
			appendedDiv.addClass( 'active' );
			if ( appendedDiv.length === 0 ) {
				// Append div on frontend
				appendedDiv = jQuery( '<div>' ).addClass( 'select__tag d-flex active' );
				const spanElement = jQuery( '<span>' ).text( value );
				appendedDiv.append( spanElement );
				jQuery( '#selected-value-container' ).append( appendedDiv );
			}
		} else {
			jQuery( this ).removeClass( 'active' );
			appendedDiv.removeClass( 'active' );
			appendedDiv.filter( ':contains("' + value + '")' ).remove(); // Remove corresponding HTML
		}
	} );

	// Handle appended div click event
	jQuery( document ).on( 'click', '.select__tag', function() {
		const value = jQuery( this ).find( 'span' ).text();
		const checkbox = jQuery( '.catagory-checkbox[value="' + value + '"]' );
		checkbox.prop( 'checked', false );
		checkbox.trigger( 'change' );
		( this ).remove();
	} );
	jQuery( '#grant-size-select-options li span' ).on( 'click', function() {
		jQuery( '#grant-size-select-options li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );
	jQuery( '#year-select-options li span' ).on( 'click', function() {
		jQuery( '#year-select-options li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );
	jQuery( '#state-selects-options li span' ).on( 'click', function() {
		jQuery( '#state-selects-options li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );
	const page = 2;
	// Submit event handler for the search form
	jQuery( '#ajax-filter-trigger ' ).on( 'click', function( e ) {
		e.preventDefault(); // Prevent form submission
		const searchData = jQuery( '#grant-search' ).val();
		loader = jQuery( '<div class="loader">Loading...</div>' );
		const orgtype = [];
		const termSlug = [];
		let minGrantSize = '';
		let maxGrantSize = '';
		let year = '';
		let state = '';
		let filterType = 'normal';
		let page = 1;
		if ( jQuery( this ).attr( 'data-type' ) === 'pagination' ) {
			page = jQuery( this ).attr( 'data-next' );
			filterType = 'pagination';
		}
		jQuery( '#grant-orgtype-checkboxes label' ).each( function() {
			  const item = jQuery( this ).find( 'input' );
			  if ( jQuery( item ).hasClass( 'active' ) ) {
				  orgtype.push( item.data( 'orgtype' ) );
			}
		} );
		jQuery( '#grant-size-select-options ul li' ).each( function() {
			const item = jQuery( this ).find( 'span' );
			if ( jQuery( item ).hasClass( 'active' ) ) {
				minGrantSize = item.data( 'min' );
				maxGrantSize = item.data( 'max' );
			}
		} );
		jQuery( '#year-select-options ul li' ).each( function() {
			const item = jQuery( this ).find( 'span' );
			if ( jQuery( item ).hasClass( 'active' ) ) {
				year = item.data( 'year' );
			}
		} );
		jQuery( '#state-selects-options ul li' ).each( function() {
			const item = jQuery( this ).find( 'span' );
			if ( jQuery( item ).hasClass( 'active' ) ) {
				state = item.data( 'state' );
			}
		} );
		jQuery( '#catagories-checkboxes label' ).each( function() {
			  const item = jQuery( this ).find( 'input' );
			  if ( jQuery( item ).hasClass( 'active' ) ) {
				  termSlug.push( item.data( 'slug' ) );
			}
		} );
		jQuery( '.init-loader' ).css( 'display', 'block' );
		// Make an AJAX request to retrieve search results

		if ( filterType === 'normal' ) {
			jQuery( '#grant-container' ).empty( );
		}
		jQuery( this ).html( loader );
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'grant_search_filter',
				search_data: searchData,
				org_Type: orgtype,
				slug: termSlug,
				min_value: minGrantSize,
				max_value: maxGrantSize,
				year,
				state,
				page,

			},
			success( response ) {
				if ( filterType === 'normal' ) {
					jQuery( '#grant-container' ).html( response.html );
				} else {
					jQuery( '#grant-container' ).append( response.html );
				}
				jQuery( '#ajax-filter-trigger ' ).html( 'Load More' );
				jQuery( '.init-loader' ).css( 'display', 'none' );
				jQuery( '.load-more-grant' ).attr( 'data-current', page );
				jQuery( '.load-more-grant' ).attr( 'data-next', response.paged );
				jQuery( '.load-more-grant' ).attr( 'data-pages', response.max_num_pages );
				jQuery( '.load-more-grant' ).show();

				if ( response.paged > response.max_num_pages ) {
					jQuery( '.load-more-grant' ).hide();
				}
				if ( response.max_num_pages < 2 ) {
					jQuery( '.load-more-grant' ).hide();
				}
			},
			error( xhr, textStatus, errorThrown ) {

			},
		} );
	} );
} );
/**
 *Search Filter For Grant
 */
